import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { ColumnSelectionModule } from '../../columns/column-selection/column-selection.module';
import { FilterSelectionModule } from '../../filter/filter-selection/filter-selection.module';
import { MatRowKeyboardSelectionModule } from '../../../core/directive/mat-row-keyboard-selection.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MaterialFormModule } from '../materail-form/material-form.module';
import { MaterialNewComponent } from './material-new.component';
import { DefaultHeaderModule } from '../../default-header/default-header.module';
import { ToggleMenuButtonModule } from '../../toggle-menu-button/toggle-menu-button.module';
import { UserProfileToolbarModule } from 'src/app/components/user-profile-toolbar/user-profile-toolbar.module';

@NgModule({
  declarations: [MaterialNewComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MatTableModule,
    ColumnSelectionModule,
    FilterSelectionModule,
    MatRowKeyboardSelectionModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MaterialFormModule,
    DefaultHeaderModule,
    ToggleMenuButtonModule,
    UserProfileToolbarModule,
  ],
  exports: [MaterialNewComponent],
  providers: [],
})
export class MaterialNewModule {}
